export default function getSingleProductPrice(data) {
    return data?.price_range?.minimum_price?.final_price?.value || null;
}
//# sourceMappingURL=getSingleProductPrice.js.map